(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambassador-portal"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.zp-port').forEach(function(root) {
    if (root.dataset.zpPortInit) return;
    root.dataset.zpPortInit = '1';

    root.querySelectorAll('[data-copy-target]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = root.querySelector(btn.getAttribute('data-copy-target'));
        if (!target) return;
        var text = target.dataset.code || target.textContent;
        var done = function() {
          var orig = btn.textContent;
          btn.textContent = 'Copied ✓';
          btn.classList.add('is-copied');
          setTimeout(function() {
            btn.textContent = orig;
            btn.classList.remove('is-copied');
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done).catch(function() {});
        } else {
          var t = document.createElement('textarea');
          t.value = text;
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(t);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ambassador-signup-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.zp-as').forEach(function(root) {
    if (root.dataset.zpAsInit) return;
    root.dataset.zpAsInit = '1';

    // Toggle "has" appearance for niche checkboxes
    root.querySelectorAll('.zp-as__check-list input').forEach(function(el) {
      el.addEventListener('change', function() {
        el.parentElement.classList.toggle('zp-as__check--has', el.checked);
      });
    });

    // Native {% form 'contact' %} now handles submission server-side.
    // On successful post, the Liquid renders the success block — scroll it into view.
    if (root.querySelector('.zp-as__success--in')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // Require at least one social handle before submit
    var form = root.querySelector('.zp-as__form');
    var handles = root.querySelectorAll('[data-zp-handle]');
    var handlesError = root.querySelector('#zp-as-handles-error');
    if (form && handles.length && handlesError) {
      form.addEventListener('submit', function(e) {
        var hasOne = false;
        for (var i = 0; i < handles.length; i++) {
          if (handles[i].value.trim() !== '') { hasOne = true; break; }
        }
        if (!hasOne) {
          e.preventDefault();
          handlesError.hidden = false;
          handles[0].focus();
          handlesError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          handlesError.hidden = true;
          try {
            var get = function (n) {
              var el = form.querySelector('[name="contact[' + n + ']"]');
              return el ? (el.value || '') : '';
            };
            var niches = [];
            form.querySelectorAll('input[type="checkbox"][name^="contact[niche_"]:checked').forEach(function (el) {
              niches.push(el.value);
            });
            var payload = {
              first_name: get('first_name'),
              last_name: get('last_name'),
              email: get('email'),
              country: get('country'),
              whatsapp: get('whatsapp'),
              age: get('age'),
              instagram: get('instagram'),
              tiktok: get('tiktok'),
              youtube_other: get('youtube_other'),
              audience_size: get('audience_size'),
              niches: niches.join(', '),
              body: get('body'),
              current_pouches: get('current_pouches')
            };
            sessionStorage.setItem('zp-as-pending', JSON.stringify(payload));
          } catch (err) {}
        }
      });
      handles.forEach(function(h) {
        h.addEventListener('input', function() {
          var hasOne = false;
          for (var i = 0; i < handles.length; i++) {
            if (handles[i].value.trim() !== '') { hasOne = true; break; }
          }
          if (hasOne) handlesError.hidden = true;
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.zp-fq').forEach(function(root) {
    if (root.dataset.zpFqInit) return;
    root.dataset.zpFqInit = '1';

    const links = [...root.querySelectorAll('.zp-fq__side a[data-cat]')];
    const cats  = [...root.querySelectorAll('.zp-fq__cat')];
    const qa    = [...root.querySelectorAll('details.zp-fq__qa')];
    const input = root.querySelector('#zp-fq-search');
    const status = root.querySelector('.zp-fq__search-status');

    /* ---------- Sidebar scroll-spy (IntersectionObserver) ----------
       A category becomes active when its top edge crosses into the
       upper ~25% of the viewport. We pick the active id by finding
       the LAST entry whose top is at or above that line. */
    const setActive = (id) => {
      links.forEach(a => a.classList.toggle('is-active', a.getAttribute('data-cat') === id));
    };

    if (cats.length) {
      const updateActive = () => {
        const trigger = window.innerHeight * 0.25;
        let activeId = cats[0].getAttribute('data-cat');
        for (const c of cats) {
          const top = c.getBoundingClientRect().top;
          if (top - trigger <= 0) {
            activeId = c.getAttribute('data-cat');
          } else {
            break;
          }
        }
        setActive(activeId);
      };
      updateActive();
      window.addEventListener('scroll', updateActive, { passive: true });
      window.addEventListener('resize', updateActive, { passive: true });

      // Smooth-scroll the sidebar links with a small offset for the sticky header
      links.forEach(a => {
        a.addEventListener('click', (e) => {
          const target = document.getElementById(a.getAttribute('href').slice(1));
          if (!target) return;
          e.preventDefault();
          const offset = 100;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: 'smooth' });
        });
      });
    }

    /* ---------- Search ----------
       As the user types, filter the question list and update a live
       results count. We match against the question title AND the
       answer body. Matched questions auto-open so the user sees
       the matching text in context — same behavior as the original
       prototype.
       On an empty query the original "first question open" state is
       restored by remembering which detail had the `open` attribute
       on load. */
    const titleOf = (d) => (d.querySelector('summary span:first-child')?.textContent || '').toLowerCase();
    const bodyOf  = (d) => (d.querySelector('.zp-fq__qa-body')?.textContent || '').toLowerCase();
    const initiallyOpen = qa.filter(d => d.hasAttribute('open'));

    const runSearch = () => {
      if (!input) return;
      const q = input.value.trim().toLowerCase();
      let matchCount = 0;
      let catCount = 0;

      qa.forEach(d => {
        if (!q) {
          d.style.display = '';
          d.open = initiallyOpen.includes(d);
          return;
        }
        const matched = titleOf(d).includes(q) || bodyOf(d).includes(q);
        d.style.display = matched ? '' : 'none';
        if (matched) {
          matchCount++;
          d.open = true;
        }
      });

      cats.forEach(c => {
        if (!q) { c.style.display = ''; return; }
        const any = [...c.querySelectorAll('details.zp-fq__qa')].some(d => d.style.display !== 'none');
        c.style.display = any ? '' : 'none';
        if (any) catCount++;
      });

      if (status) {
        if (!q) {
          status.textContent = '';
          status.classList.remove('is-visible');
        } else if (matchCount === 0) {
          status.textContent = 'No matches. Email service@zpack.co and we’ll get you the answer.';
          status.classList.add('is-visible');
        } else {
          status.textContent = matchCount + ' result' + (matchCount === 1 ? '' : 's')
            + ' in ' + catCount + ' categor' + (catCount === 1 ? 'y' : 'ies');
          status.classList.add('is-visible');
        }
      }
    };

    if (input) {
      input.addEventListener('input', runSearch);

      // ⌘K / Ctrl+K focuses the search input
      window.addEventListener('keydown', (e) => {
        if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
          e.preventDefault();
          input.focus();
          input.select();
        }
        if (e.key === 'Escape' && document.activeElement === input) {
          input.value = '';
          runSearch();
          input.blur();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-upper-decky"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.zp-ld').forEach(function(root) {
    if (root.dataset.zpLdInit) return;
    root.dataset.zpLdInit = '1';

    /* ---------- Pack selection ---------- */
    var packs   = [].slice.call(root.querySelectorAll('.zp-ld__pack'));
    var ctaBtn  = root.querySelector('.zp-ld__pack-cta');
    var ctaLbl  = root.querySelector('.zp-ld__pack-cta-label');
    var ctaTmpl = (ctaBtn && ctaBtn.getAttribute('data-pack-cta-template')) || 'Add {qty} × ZPACK — ${now}';

    var stickyTitle = root.querySelector('.zp-ld__sticky-pack-title');
    var stickyQty   = root.querySelector('.zp-ld__sticky-qty');
    var stickyNow   = root.querySelector('.zp-ld__sticky-now');
    var stickyWas   = root.querySelector('.zp-ld__sticky-was');
    var stickyLabel = root.querySelector('.zp-ld__sticky-btn-label');

    function applyPack(p) {
      packs.forEach(function(x) { x.classList.toggle('is-selected', x === p); });
      var qty = p.dataset.qty, now = p.dataset.now, was = p.dataset.was, title = p.dataset.title;
      if (ctaLbl) ctaLbl.textContent = ctaTmpl.replace('{qty}', qty).replace('{now}', now).replace('{title}', title);
      if (stickyTitle) stickyTitle.textContent = title;
      if (stickyQty) stickyQty.textContent = qty;
      if (stickyNow) stickyNow.textContent = '$' + now;
      if (stickyWas) stickyWas.textContent = '$' + was;
      if (stickyLabel) stickyLabel.textContent = 'Add to Cart — $' + now;
    }

    packs.forEach(function(p) {
      p.addEventListener('click', function() { applyPack(p); });
    });
    var initial = null;
    for (var i = 0; i < packs.length; i++) {
      if (packs[i].classList.contains('is-selected')) { initial = packs[i]; break; }
    }
    if (!initial && packs.length) initial = packs[0];
    if (initial) applyPack(initial);

    /* ---------- Smooth scroll for hero / final CTAs ---------- */
    root.querySelectorAll('a[href^="#zp-ld-"]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        var targetId = a.getAttribute('href').slice(1);
        var target = document.getElementById(targetId);
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    /* ---------- Sticky cart bar reveal ---------- */
    var sticky = root.querySelector('.zp-ld__sticky');
    if (sticky) {
      var threshold = parseInt(sticky.dataset.threshold || '700', 10);
      var onScroll = function() { sticky.classList.toggle('is-in', window.scrollY > threshold); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-page-old"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.zp-wr').forEach(function(root) {
    if (root.dataset.zpWrInit) return;
    root.dataset.zpWrInit = '1';

    // Visual selection state for finishes
    root.querySelectorAll('.zp-wr__finish-grid label').forEach(function(lbl) {
      var input = lbl.querySelector('input');
      if (!input) return;
      input.addEventListener('change', function() {
        root.querySelectorAll('.zp-wr__finish-grid label').forEach(function(l) {
          l.classList.remove('zp-wr__finish--sel');
        });
        lbl.classList.add('zp-wr__finish--sel');
      });
    });

    // Dynamic hint based on selected channel
    var channelEl = root.querySelector('.zp-wr__form select[name="channel"]');
    var hintEl = root.querySelector('#zp-wr-order-hint');
    if (channelEl && hintEl) {
      var defaultHint = hintEl.textContent;
      channelEl.addEventListener('change', function() {
        var opt = channelEl.options[channelEl.selectedIndex];
        var hint = opt && opt.dataset.hint;
        hintEl.textContent = hint && hint.length ? hint : defaultHint;
      });
    }

    // Native {% form 'contact' %} handles submission server-side now.
    // If user lands on this page with form.posted_successfully?, the
    // success block renders in Liquid — scroll it into view.
    if (root.querySelector('.zp-wr__success--in')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // Capture form values into sessionStorage on submit so the success
    // page can fire a Klaviyo "Warranty Registered" event carrying this
    // specific registration's serial/finish/date.
    var form = root.querySelector('#zp-wr-form');
    if (form) {
      form.addEventListener('submit', function () {
        try {
          var get = function (n) {
            var el = form.querySelector('[name="contact[' + n + ']"]:checked, [name="contact[' + n + ']"]:not([type=radio]):not([type=checkbox]), [name="contact[' + n + ']"][type=checkbox]:checked');
            return el ? (el.value || '') : '';
          };
          var payload = {
            first_name: get('first_name'),
            last_name: get('last_name'),
            email: get('email'),
            phone: get('phone'),
            sales_channel: get('sales_channel'),
            order_number: get('order_number'),
            purchase_date: get('purchase_date'),
            quantity: get('quantity'),
            finish: get('finish'),
            engraving: get('engraving')
          };
          sessionStorage.setItem('zp-wr-pending', JSON.stringify(payload));
        } catch (e) {}
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.zp-wr').forEach(function(root) {
    if (root.dataset.zpWrInit) return;
    root.dataset.zpWrInit = '1';

    // Native {% form 'contact' %} handles submission server-side now.
    // If user lands on this page with form.posted_successfully?, the
    // success block renders in Liquid — scroll it into view.
    if (root.querySelector('.zp-wr__success--in')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // Capture form values into sessionStorage on submit so the success
    // page can fire a Klaviyo "Warranty Registered" event carrying this
    // specific registration's serial/finish/date.
    var form = root.querySelector('#zp-wr-form');
    if (form) {
      form.addEventListener('submit', function () {
        try {
          var get = function (n) {
            var el = form.querySelector('[name="contact[' + n + ']"]:checked, [name="contact[' + n + ']"]:not([type=radio]):not([type=checkbox]), [name="contact[' + n + ']"][type=checkbox]:checked');
            return el ? (el.value || '') : '';
          };
          var payload = {
            first_name: get('first_name'),
            last_name: get('last_name'),
            email: get('email'),
            phone: get('phone'),
            sales_channel: get('sales_channel'),
            purchase_date: get('purchase_date'),
            quantity: get('quantity')
          };
          sessionStorage.setItem('zp-wr-pending', JSON.stringify(payload));
        } catch (e) {}
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
